import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, List, Drawer, Hidden, Typography, ListSubheader } from '@material-ui/core';
import { UtilsLib } from '@payface-frontends-libs/utils';
import { Logo, MyAvatar, Scrollbar } from '../../generics';
import { SidebarItem } from './SidebarItem';
const { environmentConfig } = UtilsLib.Config;
const DRAWER_WIDTH = 280;
const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
        width: DRAWER_WIDTH,
    },
}));
const AccountStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    margin: theme.spacing(1, 2.5, 5),
    borderRadius: theme.shape.borderRadiusSm,
    backgroundColor: theme.palette.grey[50012],
}));
function reduceChild({ array, item, pathname, level }) {
    const key = item.href + level;
    if (item.items) {
        const match = matchPath(pathname, {
            path: item.href,
            exact: false,
        });
        return [
            ...array,
            _jsx(SidebarItem, Object.assign({ level: level, icon: item.icon, info: item.info, href: item.href, title: item.title, open: Boolean(match) }, { children: renderSidebarItems({
                    pathname,
                    level: level + 1,
                    items: item.items,
                }) }), key),
        ];
    }
    return [
        ...array,
        _jsx(SidebarItem, { level: level, href: item.href, icon: item.icon, info: item.info, title: item.title }, key),
    ];
}
function renderSidebarItems({ items, pathname, level = 0 }) {
    return (_jsx(List, Object.assign({ disablePadding: true }, { children: items.reduce((array, item) => reduceChild({ array, item, pathname, level }), []) }), void 0));
}
export function DashboardSidebar({ isOpenSidebar, onCloseSidebar, dashboardPath, dashboardList }) {
    const { pathname } = useLocation();
    const [storageName, setStorageName] = useState('');
    const userData = JSON.parse(localStorage.getItem('@admin:user'));
    useEffect(() => {
        if (isOpenSidebar && onCloseSidebar) {
            onCloseSidebar();
        }
    }, [pathname]);
    useEffect(() => {
        const userName = userData.firstName;
        setStorageName(userName);
    }, [userData]);
    const renderContent = (_jsxs(Scrollbar, { children: [_jsx(Box, Object.assign({ sx: { px: 2.5, py: 3 } }, { children: _jsx(RouterLink, Object.assign({ to: dashboardPath.general.app }, { children: _jsx(Logo, {}, void 0) }), void 0) }), void 0), _jsxs(AccountStyle, { children: [_jsx(MyAvatar, {}, void 0), _jsxs(Box, Object.assign({ sx: { ml: 2 } }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: { color: 'text.primary' } }, { children: storageName }), void 0), _jsx(Typography, Object.assign({ variant: "body2", sx: { color: 'text.secondary' } }, { children: environmentConfig.stage }), void 0)] }), void 0)] }, void 0), dashboardList.map((list) => (_jsx(List, Object.assign({ disablePadding: true, subheader: _jsx(ListSubheader, Object.assign({ disableSticky: true, disableGutters: true, sx: {
                        mt: 3,
                        mb: 2,
                        pl: 5,
                        color: 'text.primary',
                        typography: 'overline',
                    } }, { children: list.subheader }), void 0) }, { children: renderSidebarItems({
                    items: list.items,
                    pathname,
                }) }), list.subheader)))] }, void 0));
    return (_jsxs(RootStyle, { children: [_jsx(Hidden, Object.assign({ lgUp: true }, { children: _jsx(Drawer, Object.assign({ open: isOpenSidebar, onClose: onCloseSidebar, PaperProps: {
                        sx: { width: DRAWER_WIDTH },
                    } }, { children: renderContent }), void 0) }), void 0), _jsx(Hidden, Object.assign({ lgDown: true }, { children: _jsx(Drawer, Object.assign({ open: true, variant: "persistent", PaperProps: {
                        sx: { width: DRAWER_WIDTH, bgcolor: 'background.default' },
                    } }, { children: renderContent }), void 0) }), void 0)] }, void 0));
}
//# sourceMappingURL=DashboardSidebar.js.map